import React from "react"
import { css } from "@emotion/core"
import { mq } from "../mixins"
import Brush from "./hero_brush"
import Button from "../Button/button"
import { ReturnDateAndTime } from "../../utils"

import "./hero.scss"

const Hero = props => {
  const Hero = css`
    height: ${props.header_size === "half" ? "450px" : "768px"} !important;
  `

  const HeroContent = css`
    ${mq("tablet")} {
      margin-top: ${props.header_size === "half" ? "50px" : "0"};
    }
  `
  return (
    <>
      <div className="hero" css={Hero}>
        <div className="hero__content" css={HeroContent}>
          <div className="container">
            {!!props.headline_icon && (
              <img className="hero__headline_icon" src={props.headline_icon.url} alt={props.headline_icon.title}></img>
            )}
            <div className="hero__headline-container">
              {props.header_size === "half" &&
                props.brush_stroke_color.colors !== null && (
                  <div className="hero__brush">
                    <Brush
                      brush_stroke_color={props.brush_stroke_color.colors}
                    />
                  </div>
                )}
              {props.header_size === "half" ? (
                <h1 className="hero__headline hero__headline--smaller">{props.headline}</h1>
              ) : (
                <h1 className="hero__headline">{props.headline}</h1>
              )}
            </div>
            {props.subhead !== "" && (
              <p className="hero__subline">{props.subhead}</p>
            )}
            {props.button.length !== 0 && (
              <div className="button__container">
                {props.button.map((data, index) => {
                  return (
                    <Button
                      key={index}
                      button_link={data.button_link.href}
                      button_link_type={data.button_link_type}
                      button_text={data.button_text}
                      button_color={data.button_color}
                      button_type={data.button_type}
                      text_color={data.text_color}
                    />
                  )
                })}
              </div>
            )}
            <div className="hero__apps">
              {props.promotional_text !== null &&
                props.promotional_text !== undefined &&
                props.promotional_text[0] && (
                  <>
                    <p className="hero__promotion">
                      {props.promotional_text[0].mkt_copy}
                      <br />
                      {props.promotional_text[0].subhead}
                    </p>
                  </>
                )}
              <div className="hero__apps-icons">
                {props.app_icon &&
                  props.app_icon.map((data, index) => {
                    return (
                      <div className="hero__apps-icon" key={index}>
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href={data.app_url.href}
                        >
                          <img src={data.badge[0].badge.url} alt="app icon" />
                        </a>
                      </div>
                    )
                  })}
              </div>
            </div>
          </div>
        </div>
      </div>
      {props.last_update && (
        <p className="hero__last-update">{`Last Update: ${ReturnDateAndTime(
          props.last_update
        )}`}</p>
      )}
    </>
  )
}

export default Hero
